import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { ReplaceLimitItemsSchema } from '@app/models/products';
import Api from '@app/services/api';

interface IProps {
  items: ReplaceLimitItemsSchema;
  limitUid: string;
}

export const useUpdateCatalogLimitQuery = () => {
  const client = useQueryClient();
  const catalogsT = useTranslation(NSKeys.catalogs);

  return useMutation({
    mutationFn: async ({ items, limitUid }: IProps) => {
      await Api.products.putCatalogLimitItems(limitUid, items);
    },
    onSuccess: async () => {
      await client.invalidateQueries(['getCatalogLimits']);
      await client.invalidateQueries(['getCatalogLimit']);
      message.open({
        type: 'success',
        content: catalogsT.t('limits.toastUpdateSuccess'),
      });
    },
  });
};
